export default __webpack_public_path__ + "static/media/first.33a47a05.png";